module.exports = __webpack_public_path__ + "f8ceaff94cca158f8a1701e2ba6668a9.svg";